export default __webpack_public_path__ + "static/media/Sorcerer's Hood of Sovereign Rule.b4a2838d.jpg";